<template>
  <div class="mb-cropp-img" id="mb-cropp-img">
    <tr-canvas v-if="clearStat" style="z-index: 22222222"></tr-canvas>
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        top: startGameConfig.mainImage.pos.y + 'px' || 0 + 'px',
        left: startGameConfig.mainImage.pos.x + 'px' || 0 + 'px',
        width: startGameConfig.mainImage.width + 'px' || 1920 + 'px',
        height: startGameConfig.mainImage.height + 'px' || 1080 + 'px',
      }"
    />
    <transition name="modal-fade">
      <answer-modal
        v-if="showAnswer"
        :img-src="startGameConfig.croppImg[currentCrop].answer"
        :cropp-image="startGameConfig.croppImg[currentCrop].answer.croppImage"
        @modal-off="modalOff()"
      ></answer-modal>
    </transition>
    <div
      :key="'cropp' + index"
      v-for="(item, index) in startGameConfig.croppImg"
      :class="{ box: currentCrop == index }"
    >
      <transition :name="currentTransition">
        <div
          class="box"
          id="mb-cropp-img-box"
          style="overflow: hidden"
          :style="[
            currentCrop == index
              ? { 'z-index': 1, opacity: 1, 'transition-delay': '0.3s' }
              : { 'x-index': 0, opacity: 0 },
          ]"
        >
          <cropp-image :img-config="item"> </cropp-image>
          <div
            id="signature-pad"
            style="opacity: 0"
            :style="{
              width: '90%',
              height: 'calc(' + 100 + '% - ' + item.cropp.height + 'px - 10vh)',
            }"
            :ref="'signaturePad-' + index"
            class="drawable-answer"
            :options="options"
          ></div>
          <!-- <div class="colors-box">
            <div class="color" v-for="itm in item.colors || colors" :key="itm">
              <div
                :style="[{ background: itm }, options.penColor == itm ? { opacity: 1 } : { opacity: 0.5 }]"
                style="width: 100%; height: 100%; transition: .5s"
                @click="change(itm)"
              ></div>
            </div>
          </div> -->
          <div>
            <!-- <div class="icon-box" @click="undo(index)" title="cofnij">
              <svg class="icon-svg" viewBox="0 0 24 24">
                <path
                  d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
                />
              </svg>
            </div> -->
            <!-- <div class="icon-box" @click="clear(index)" title="wyczyść">
              <svg class="icon-svg" viewBox="0 0 24 24">
                <path
                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                />
              </svg>
            </div>
            <div
              class="icon-box"
              v-if="startGameConfig.croppImg[currentCrop].answer"
              @click="showAnswer = true"
              title="pokaż odpowiedz"
            >
              <svg class="icon-svg" viewBox="0 0 24 24">
                <path
                  d="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
                />
              </svg>
            </div> -->
          </div>
          <mb-audio-in-game
            :key="data.top + data.left + 'audio' + indexAudio"
            v-for="(data, indexAudio) in item.mbAudioItemData"
            :item-data="data"
          ></mb-audio-in-game>
        </div>
      </transition>
    </div>
    <svg
      v-if="currentCrop != startGameConfig.croppImg.length - 1"
      width="8vh"
      class="next"
      height="8vh"
      viewBox="0 0 400 400"
      @click="next(1)"
    >
      <g>
        <circle id="svg_29" cy="200" cx="200" r="180" stroke-width="0" fill="#e6e6e6" />
        <path
          class="path"
          id="svg_22"
          d="m135.228828,260.427728l60.44279,-60.442457l-60.44279,-60.442891l34.546114,-34.542387l94.996235,94.985278l-94.996235,95.014748"
          stroke-opacity="0"
          stroke-width="8"
          fill="white"
        />
      </g>
    </svg>
    <svg
      v-if="currentCrop != 0"
      width="8vh"
      class="prv"
      height="8vh"
      viewBox="0 0 400 400"
      @click="next(-1)"
      style="transform: rotate(180deg)"
    >
      <g>
        <circle id="svg_29" cy="200" cx="200" r="180" stroke-width="0" fill="#e6e6e6" />
        <path
          class="path"
          id="svg_22"
          d="m135.228828,260.427728l60.44279,-60.442457l-60.44279,-60.442891l34.546114,-34.542387l94.996235,94.985278l-94.996235,95.014748"
          stroke-opacity="0"
          stroke-width="8"
          fill="white"
        />
      </g>
    </svg>
    <div class="steps-box" v-if="startGameConfig.croppImg.length != 1">
      <div
        class="step"
        :key="'step-' + index"
        @click="goToStep(index)"
        v-for="(item, index) in startGameConfig.croppImg"
        :style="[currentCrop == index ? { opacity: 1 } : { opacity: 0.5 }]"
      ></div>
    </div>
    <transition name="slide">
      <div style="position: fixed; bottom: 0">
        <tr-canvas-toolbox class="toolbox-class"> </tr-canvas-toolbox>
      </div>
    </transition>
    <tr-navi-canvas-toolbox></tr-navi-canvas-toolbox>
    <mb-audio-in-game
      :key="data.top + data.left + 'audio' + index"
      v-for="(data, index) in startGameConfig.mbAudioItemData"
      :item-data="data"
    ></mb-audio-in-game>
  </div>
</template>
<script>
import TrCanvas from './trCanvas/trCanvas';
// import TrCanvas from '../../../FooterNavi/SubComponents/TrCanvas';
import AnswerModal from './AnswerModal/AnswerModal';
import CroppImage from '../../../CroppImage/CroppImage';
import defaultMixin from '../../mixins/defaultMixin';
import mbAudioInGame from '../../../MbAudioModal/MbAudioInGame';
import TrNaviCanvasToolbox from '../../../FooterNavi/SubComponents/TrNaviCanvasToolbox';
import TrCanvasToolbox from '../../../FooterNavi/SubComponents/TrCanvasToolbox/TrCanvasToolbox';
import $ from 'jquery';
export default {
  name: 'mb-cropp-img',
  components: { AnswerModal, mbAudioInGame, CroppImage, TrNaviCanvasToolbox, TrCanvasToolbox, TrCanvas },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      // clearStat: true,
      colors: ['red', 'green', 'blue', 'black', 'yellow'],
      showAnswer: false,
      currentCrop: 0,
      currentTransition: 'click-fade-next',
      signaturePen: {
        width: null,
        height: null,
      },
      options: {
        penColor: 'black',
        throttle: 0,
        minDistance: 0,
      },
    };
  },
  created() {},
  beforeMount() {
    this.$store.commit('CHANGE_CANVAS_TOOL_COLOR', '#000000');
    console.log('hi');
    this.$store.commit('TOGGLE_CANVAS');
    this.init();
  },
  beforeDestroy() {
    this.$store.commit('CHANGE_CANVAS_TOOL_COLOR', '#000000');
    // this.clearStat = false;
    console.log('exit');
    this.$store.commit('TOGGLE_CANVAS');
  },
  mounted() {
    // this.$store.commit('TOGGLE_CANVAS_TEXT_MARKER');
    let doc = document.getElementsByTagName('canvas');
    let doc2 = document.getElementById('app');
    let $innerWindow = $('#scaleable-wrapper');
    let $el = $('#very-specific-design');
    let $sp = $('#signature-pad');
    let elHeight = $el.outerHeight();
    let elWidth = $el.outerWidth();
    let scale;
    scale = Math.min($innerWindow.outerWidth() / elWidth, $innerWindow.outerHeight() / elHeight);
    for (let i = 0; i < doc.length; i++) {
      if (doc[i].id == '') {
        doc[i].width = $sp.outerWidth() * scale;
        doc[i].height = $sp.outerHeight() * scale;
      }
    }
    if (
      this.startGameConfig.croppImg[0].answer.src != '' ||
      this.startGameConfig.croppImg[0].answer.croppImage.src != ''
    ) {
      setTimeout(() => {
        this.$store.commit('CHANGE_BLOCK_CHECK_ACTION', false);
        this.$store.commit('CHANGE_CHECK_SWITCH', false);
      }, 500);
    }
  },
  methods: {
    checkGameAction() {
      this.showAnswer = true;
      return true;
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    resetGameAction() {
      this.clearAll();
      // this.init();
      // this.goToStep(0);
      // this.change('black');
    },
    setColors() {
      this.colors = this.startGameConfig.croppImg[this.currentCrop].colors || [
        'red',
        'green',
        'blue',
        'black',
        'yellow',
      ];
    },
    clearAll() {
      // this.startGameConfig.croppImg.forEach((item, index) => {
      //   this.clear(index);
      // });
      this.$store.commit('CHANGE_MBCROPPIMGCANVAS_ACTIVE', false);
      setTimeout(() => {
        this.$store.commit('CHANGE_MBCROPPIMGCANVAS_ACTIVE', true);
      }, 500);
    },
    beforeDestroy() {
      console.log('exit');
      // this.$store.commit('TOGGLE_CANVAS');
      // this.$store.commit('TOGGLE_CANVAS_TOOLBOX');
      // this.$store.commit('TOGGLE_CANVAS_TEXT_MARKER', false);
      // this.$store.commit('TOGGLE_CANVAS_TEXT_MARKER', false);
    },
    init() {
      // this.$store.commit('TOGGLE_CANVAS');
      // this.$store.commit('TOGGLE_CANVAS_TOOLBOX');
      if (this.startGameConfig.shuffle) {
        this.shuffle(this.startGameConfig.croppImg);
      }
      //this.setColors();
      let doc = document.getElementById('mb-cropp-img');
    },
    setScale(h) {
      let doc = document.getElementById('mb-cropp-img');
      return {
        width: doc.offsetWidth * 0.9,
        height: doc.offsetHeight * 0.9 - h,
      };
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    modalOff() {
      this.showAnswer = false;
    },
    change(color) {
      this.options = {
        penColor: color,
      };
    },
    next(value) {
      // if (value == 1) {
      //   this.currentTransition = 'click-fade-next';
      // } else {
      //   this.currentTransition = 'click-fade-prv';
      // }
      this.clearAll();
      this.$nextTick(() => {
        //this.change('black');
        this.currentCrop = this.currentCrop + value;
        //this.setColors();
      });
    },
    goToStep(value) {
      // if (value > this.currentCrop) {
      //   this.currentTransition = 'click-fade-next';
      // } else {
      //   this.currentTransition = 'click-fade-prv';
      // }
      this.clearAll();
      this.$nextTick(() => {
        //this.change('black');
        this.currentCrop = value;
      });
    },
    undo(index) {
      let elem = this.$refs['signaturePad-' + index];
      elem[0].undoSignature();
    },
    clear(index) {
      let elem = this.$refs['signaturePad-' + index];
      elem[0].clearSignature();
      //this.$refs.signaturePad.clearSignature();
    },
    toBase64(index) {
      let elem = this.$refs['signaturePad-' + index];
      return elem[0].saveSignature().data;
      //console.log(elem[0].saveSignature().data);
    },
  },
  computed: {
    clearStat() {
      return this.$store.getters.mbCroppImgCanvasActive;
    },
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 900px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0

.mb-cropp-img
  background-size: contain
  background-repeat: no-repeat
  position: relative
  top: $backgroundOffsetTop
  left: $backgroundOffsetLeft
  height: $backgroundHeight
  width: $backgroundWidth
  //overflow: hidden
  top: 50px
  .main-img
    position: fixed
    object-fit: cover
  .box
    width: 100%
    height: 100%
    position: absolute
    top: 0
    display: flex
    transition: 1s
    //justify-content: center
    justify-content: space-evenly
    align-items: center
    flex-direction: column
    #cropped
      object-fit: none
      padding: 0
    .drawable-answer
      border: 1px solid black
      text-align: center
      background: white
    .colors-box
      width: 80%
      .color
        width: 6%
        height: 5vh
        margin-left: .25%
        margin-right: .25%
        display: inline-block
  .prv
    position: absolute
    top: 50%
    left: 0%
    z-index: 3
    path
      transition: .5s
    &:hover
      path
        fill: #5d5d5d
  .next
    position: absolute
    top: 50%
    right: 0%
    z-index: 3
    path
      transition: .5s
    &:hover
      path
        fill: #5d5d5d
  .steps-box
    position: absolute
    width: 100%
    height: 4vh
    bottom: -5vh
    left: 0vh
    .step
      width: 4vh
      height: 4vh
      margin: 0vh .25vh 0vh .25vh
      background: #00a8ec
      border-radius: 50%
      transition: .5s
      display: inline-block
  .icon-box
    width: 6vh
    height: 6vh
    display: inline-block
    background: #00a8ec
    border-radius: 50%
    transition: .5s
    border: 1px solid #00a8ec
    .icon-svg
      width: 100%
      transform: scale(.8)
      height: 100%
      fill: white
      transition: .5s
      vertical-align: inherit
    &:hover
      background: white
      .icon-svg
        fill: #00a8ec
.click-fade-next-leave-active, .click-fade-next-enter-active
  transition: all .3s linear
.click-fade-next-leave-to
  transform: translateX(20%)
  opacity: 0
.click-fade-next-enter
  opacity: 0

.click-fade-prv-leave-active, .click-fade-prv-enter-active
  transition: all .3s linear
.click-fade-prv-leave-to
  opacity: 0
.click-fade-prv-enter
  transform: translateX(20%)
  opacity: 0
.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .5s linear
.modal-fade-leave-to, .modal-fade-enter
  transform: scale(2,2)
  opacity: 0
</style>
